module.exports = __webpack_public_path__ + "static/media/subscription-background.8c596cd6.jpg";